import { useFetchServicePreferences } from '@/hooksApi';

/**
 * The service level an order shipped on, for a table cell.
 *
 * Exists because Boxy Select removes the carrier column entirely (spec §7.2)
 * and left the list with nothing at all to say about how an order ships. The
 * service is the honest answer: it is what the merchant actually chose, and it
 * is meaningful in both modes.
 *
 * A component rather than a `render` closure so the catalogue can be read with
 * a hook. React Query dedupes the
 * request across every row, so this is one fetch for the page, not one per row.
 */
export function ServiceCell({ serviceCode }: { serviceCode?: string | null }) {
  const { data } = useFetchServicePreferences();

  // An order created before the catalogue existed carries no code, and a
  // retired service is no longer in the list — both render the same dash the
  // rest of this table uses for "nothing to show", never a raw slug.
  const service = data?.services?.find((item) => item.code === serviceCode);

  return <span className='whitespace-nowrap'>{service?.title ?? '---'}</span>;
}

export default ServiceCell;
